import SharedNavbar from '@/components/feature/SharedNavbar';
import HeroSection from './components/HeroSection';
import BrandStorySection from './components/BrandStorySection';
import LaunchGallerySection from './components/LaunchGallerySection';
import RoutineSection from './components/RoutineSection';
import CTASplitSection from './components/CTASplitSection';
import ArticlesSection from './components/ArticlesSection';
import AuthenticitySection from './components/AuthenticitySection';
import NewsletterSection from './components/NewsletterSection';
import SharedFooter from '@/components/feature/SharedFooter';
import { usePageSections } from '@/hooks/usePageSections';
import { Seo } from '@/components/Seo';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import HomeV2 from './v2/HomeV2';

// Organization schema lives on the homepage only (standard practice —
// Google associates a site-wide Organization/WebSite entity from wherever
// it's declared, doesn't need repeating on every page).
const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Rx.K Seoul',
  url: 'https://rxk.thekseoul.com',
  logo: 'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/f5cf2a60-a2a7-427e-991d-7421fb780794_logo_Rx.K-Seoul_Transparent.png',
  sameAs: [],
};

export default function HomePage() {
  const isSectionVisible = usePageSections('home');
  const { isNew } = useSiteDesign();

  return (
    <main className="w-full min-h-screen bg-white font-sans">
      <Seo pageKey="home" jsonLd={organizationSchema} />
      <SharedNavbar />
      {isNew ? (
        <div style={{ paddingTop: 'var(--v2h-h, 64px)' }}>
          <HomeV2 />
        </div>
      ) : (
        <>
          {isSectionVisible('hero') && <HeroSection />}
          {isSectionVisible('brandStory') && <BrandStorySection />}
          {isSectionVisible('launchGallery') && <LaunchGallerySection />}
          {isSectionVisible('routine') && <RoutineSection />}
          {isSectionVisible('ctaSplit') && <CTASplitSection />}
          {isSectionVisible('articles') && <ArticlesSection />}
          {isSectionVisible('authenticity') && <AuthenticitySection />}
          {isSectionVisible('newsletter') && <NewsletterSection />}
        </>
      )}
      <SharedFooter />
    </main>
  );
}
